import CommonDataService from "../../service/CommonDataService";
import { setNotificationData } from "./uiActions";

export const OKTA_USER_INFO = 'OKTA_USER_INFO';
export const SET_MARKET_LANGUAGES = 'SET_MARKET_LANGUAGES';
export const SET_MARKET_LANGUAGES_LOADER = 'SET_MARKET_LANGUAGES_LOADER';

export const setOktaUserInfo = (options) => {
  return {
    type: OKTA_USER_INFO,
    payload: options,
  };
};

export const setMarketLanguages = (options) => {
  return {
    type: SET_MARKET_LANGUAGES,
    payload: options,
  };
}

export const setMarketLanguagesLoader = (options) => {
  return {
    type: SET_MARKET_LANGUAGES_LOADER,
    payload: options,
  };
}

export const fetchMarketLanguages = (history, redirect) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const prevURL = state.uiState?.lastVisitedUrl || '/dashboard';

      dispatch(setMarketLanguagesLoader(true));

      const response = await CommonDataService.getMarketLanguages();
      
      if (response?.data) {
        dispatch(setMarketLanguages(response?.data));

        if (redirect != 'false') {
          history.push(prevURL);
        }
      } else {
        dispatch(setMarketLanguages([]));
        localStorage.clear();
        dispatch(
        setNotificationData({
          show: true,
          type: 'WARNING',
          title: 'Failed to fetch market languages',
          description: ``,
        }),
      );
      }
      
    } catch (error) {
      console.log('error', error);
      dispatch(setMarketLanguages([]));
      dispatch(
        setNotificationData({
          show: true,
          type: 'WARNING',
          title: 'Failed to fetch market languages',
          description: ``,
        }),
      );
    } finally {
      dispatch(setMarketLanguagesLoader(false));
    }
  };
};
